import React, { useRef, useEffect, useState } from 'react';
import RepaymentPlanDetails from 'components/RepaymentPlanDetails/RePaymentPlanDetails';
import { ComponentToPrint } from './ComponentToPrint/Componenttoprint';
import PageLink from 'components/PageLink/PageLink';
import ReactToPrint from 'react-to-print';
import styles from './UpdatePaymentPlanSummaryPageData.module.scss';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import { getTemplateString } from 'common/helpers/string';
import { useAppSelector } from 'app/hooks';
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { Adjust_payment_plan, Plan_update_type } from 'common/consts/GtmVariableValues';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const UpdatePaymentPlanSummaryPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  let componentRef = useRef(null);
  const installmentMonthTemplate = getTemplateString(
    PageData?.PaymentInfoinstallmentMonthMessage,
  );
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const ERROR_ICONS_PATH = `${process.env.PUBLIC_URL}/images/icons/`;
  const paymentCompleteCheck = `${ERROR_ICONS_PATH}/payment-complete-check.svg`;
  const currentMarket = useAppSelector(selectCurrentMarket);
  const paymentPlanTypeTemplate = getTemplateString(
    PageData?.PaymentInfoThankYouMessage,
  );
  const planDueDateTemplate = getTemplateString(
    PageData?.PaymentInfoDateMessage,
  );
  const planDueDateManualTemplate = getTemplateString(
    PageData?.PaymentInfoDateManualMessage,
  );
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length > 0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);
  useEffect(() => {
    if (eventTracked == false) {
      var agreedAmount = parseFloat((Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw ? Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw : "0"));
      var finalAmount = parseFloat((Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw ? Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw : "0"));
      var adjustType = Model?.PlanDetails?.PaymentPlanType == 'Update payment plan payment method' ? Adjust_payment_plan.PaymentMethod :
        Model?.PlanDetails?.PaymentPlanType == 'Update payment plan amount' ? Adjust_payment_plan.RateAmount :
          Model?.PlanDetails?.PaymentPlanType == 'Update payment plan date' ? Adjust_payment_plan.PaymentDate : "";

      var updateType = Model?.PlanDetails?.PaymentPlanType == 'Update payment plan payment method' ? Plan_update_type.PaymentMethodUpdate :
        Model?.PlanDetails?.PaymentPlanType == 'Update payment plan amount' ? Plan_update_type.AmountUpdate :
          Model?.PlanDetails?.PaymentPlanType == 'Update payment plan date' ? Plan_update_type.DateUpdate : "";

      var installmentRemaining = (Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw == Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw) ? Model?.PlanDetails?.PlanDetailsNumberofInstallmentsRaw : Model?.PlanDetails?.PlanDetailsNumberofInstallmentsRaw - 1;

      if (!Model?.IsManualPaymentMethod) {
        var tagManagerArgs: any;
        tagManagerArgs = {
          dataLayer: {
            event: 'adjust_payment_plan',
            adjust_type: adjustType,
            payment_method: Model?.PlanDetails?.PlanDetailsPaymentMethodRaw,
            payment_frequency: 'Monthly',
            installment_count: installmentRemaining,
            final_installment_amount: (finalAmount > 0
              ? finalAmount / 100
              : 0
            ).toFixed(2),
            agreed_rate_amount: (agreedAmount > 0
              ? agreedAmount / 100
              : 0
            ).toFixed(2),
            self_payer: Model?.IsManualPaymentMethod,
            payment_type: 'Payment Plan Adjusted',
            checkout_name: 'Payment Plan Update',
            ecommerce: {
              transaction_id: Model?.PlanDetails.ExternalReference,
              affiliation: 'Hoist Finance',
              value: '1',
              currency: Model?.Currency,
              items: [
                {
                  item_id: 'Payment Plan Adjusted',
                  item_name: 'Payment Plan Adjusted',
                  price: '1',
                  quantity: '1',
                },
              ],
            }
          },
        };
        TagManager.dataLayer(tagManagerArgs);
      }
      else {
        var tagManagerArgs: any;
        tagManagerArgs = {
          dataLayer: {
            event: 'adjust_payment_plan',
            adjust_type: adjustType,
            payment_method: Model?.PlanDetails?.PlanDetailsPaymentMethodRaw,
            payment_frequency: 'Monthly',
            installment_count: installmentRemaining,
            final_installment_amount: (finalAmount > 0
              ? finalAmount / 100
              : 0
            ).toFixed(2),
            agreed_rate_amount: (agreedAmount > 0
              ? agreedAmount / 100
              : 0
            ).toFixed(2),
            self_payer: Model?.IsManualPaymentMethod,
            payment_type: 'Payment Plan Adjusted',
            checkout_name: 'Payment Plan Update',
          },
        };
        TagManager.dataLayer(tagManagerArgs);
      }
      setEventTracked(true);
    }
  }, [eventTracked]);
  return (
    <div className={styles.wrapper}>
      <div className="Section--secondaryBg">
        <div className="Page-container PageContainer--transparent">
          <section className="Section Section--portal u-paddingTz">


            {(currentMarket === Market.PL ||
              currentMarket === Market.BE ||
              currentMarket === Market.NL) && (
                <div className="CreateRepaymentPlan u-paddingBz">
                  <section className="CreateRepaymentPlan__section u-marginBz">
                    <div className="settlementAgreed">
                      <div className="settlementAgreed__section">

                        <h2 className="settlementAgreed__heading">
                          {PageData?.Heading}
                        </h2>
                        <div className="u-marginTsm">
                          <img
                            className="settlementAgreed__icon"
                            src={paymentCompleteCheck}
                          />
                        </div>
                        {Model.WithCallCenterPlan ? (
                          <>{PageData?.PaymentInfoMessage}</>
                        ) : (
                          <>{PageData.Message}</>
                        )}

                      </div>
                    </div>
                  </section>
                </div>
              )}

            {currentMarket !== Market.PL &&
              currentMarket !== Market.BE &&
              currentMarket !== Market.NL && (
                <>
                  <div className="CreateRepaymentPlan u-paddingBz">
                    <section className="CreateRepaymentPlan__section u-marginBz">
                      <h2 className={styles.heading}>
                        <span>
                          <img
                            src={`${process.env.PUBLIC_URL}/images/icons/payment-check.svg`}
                            width="24"
                          />
                        </span>
                        {PageData.Heading}
                      </h2>
                      <div className={styles.summarycontainer}>
                        <p
                          className={styles.para}
                          dangerouslySetInnerHTML={{
                            __html: Model?.ChoosingPaymentMethodMessage,
                          }}
                        />
                        {Model?.IsManualPaymentMethod ? (
                          <p
                            className={styles.para}
                            dangerouslySetInnerHTML={{
                              __html: planDueDateManualTemplate
                                ? planDueDateManualTemplate({
                                  DueDate: Model.PlanDetails.PlanDetailsFirstPaymentDueDate,
                                })
                                : '',
                            }}
                          />
                        ) :
                          (
                            <p
                              className={styles.para}
                              dangerouslySetInnerHTML={{
                                __html: planDueDateTemplate
                                  ? planDueDateTemplate({
                                    DueDate: Model.PlanDetails.PlanDetailsFirstPaymentDueDate,
                                  })
                                  : '',
                              }}
                            />
                          )}

                        {Model?.IsManualPaymentMethod && (
                          <p className={styles.para}>
                            {PageData?.PaymentInfoReturnMessage}
                          </p>
                        )}

                        {(Model?.PlanReviewDurationMonths && !Model?.IsManualPaymentMethod) && (
                          <p
                            className={styles.para}
                            dangerouslySetInnerHTML={{
                              __html: installmentMonthTemplate
                                ? installmentMonthTemplate({
                                  InstallmentMonth: Model?.PlanReviewDurationMonths,
                                })
                                : '',
                            }}
                          />
                        )}
                      </div>
                    </section>
                  </div>
                </>
              )}




            <div className="CreateRepaymentPlan">
              <section className="CreateRepaymentPlan__section">
                <div className="Repaymentlist">
                  <div className="Repaymentlist__wrapper">
                    <div className="HeadingContentSplit">
                      <h3 className="Heading HeadingContentSplit-heading_UpdateSummary">
                        {PageData.PlanSummaryHeadingLabel}
                      </h3>

                      <ReactToPrint
                        trigger={() => (
                          <a className="Link-icon Link-print print_icon_mobile">
                            <>{PageData.PrintBtnLabel}</>
                          </a>
                        )}
                        content={() => componentRef.current}
                      />
                      <div style={{ display: 'none' }}>
                        <ComponentToPrint ref={componentRef} {...props} />
                      </div>
                    </div>
                    <RepaymentPlanDetails {...props} />
                  </div>
                </div>
              </section>
            </div>





            <div className="Grid">
              <div className="Grid-cell u-textCenter u-marginTxsm">
                <PageLink
                  className="Button Button--ghost Button--mobFull"
                  text={PageData?.CloseBtnLabel}
                  url={Model?.HomePageUrl}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

  );
};

export default UpdatePaymentPlanSummaryPageData;
